import React, { Component } from 'react';
import CreateUserView from '../../components/usermanagement/createUserView';

class CreateUser extends Component {
	
	state = {
		formData: {},
	}

	componentDidMount() {        
	} 	  

	render() {
		return (
            <React.Fragment>				
                <CreateUserView data={this.state.formData}/>
            </React.Fragment>
		);
	}
}

export default CreateUser;